/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React from 'react';
import { Col, Container, Row } from "reactstrap";
// import { useAdminUserHeaderInfo } from '../../hooks/useAdminUserHeaderInfo';

const EventsListScreenHeader: React.FC = () => {
//   const { data: headerData, isLoading: headerDataLoading } = useAdminUserHeaderInfo()


  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="3">
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default EventsListScreenHeader;
